import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getEntityConfig = createAsyncThunk("entityConfig/getEntityConfig", async (payload) => {
  try {
    const response = await magnifiAPI.getEntityConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateClientSetting = createAsyncThunk("entityConfig/updateClientSetting", async (payload) => {
  try {
    const response = await magnifiAPI.updateClientSetting(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createCustomField = createAsyncThunk("entityConfig/createCustomField", async (payload) => {
  try {
    const response = await magnifiAPI.createCustomField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateCustomField = createAsyncThunk("entityConfig/updateCustomField", async (payload) => {
  try {
    const response = await magnifiAPI.updateCustomField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteCustomField = createAsyncThunk("entityConfig/deleteCustomField", async (payload) => {
  try {
    const response = await magnifiAPI.deleteCustomField(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
